export default "__VITE_ASSET__SnK2N88z__"